/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_File_Search_SuccessInputs */

const es_tools_nexata_file_search_success = /** @type {(inputs: Tools_Nexata_File_Search_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos encontrados`)
};

const en_tools_nexata_file_search_success = /** @type {(inputs: Tools_Nexata_File_Search_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files found`)
};

/**
* | output |
* | --- |
* | "Files found" |
*
* @param {Tools_Nexata_File_Search_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_file_search_success = /** @type {((inputs?: Tools_Nexata_File_Search_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_File_Search_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_file_search_success(inputs)
	return en_tools_nexata_file_search_success(inputs)
});
export { tools_nexata_file_search_success as "tools.nexata.file_search_success" }